import { useState } from 'react';

import { clientApi } from '@/config/axios';
import { Button } from '@/components/ui/button';
import { apiError, useImagingApi } from './api';

export function OrthancViewer({ studyId }: { studyId: string }) {
  const { base } = useImagingApi();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  return (
    <div className="flex flex-col gap-2">
      <Button
        disabled={busy}
        onClick={async () => {
          const viewer = window.open('about:blank', '_blank');
          if (!viewer) {
            setError('Allow a new tab to open the imaging viewer.');
            return;
          }
          viewer.opener = null;
          setBusy(true);
          setError('');
          try {
            const { data } = await clientApi.post(`${base}/studies/${studyId}/viewer`);
            if (!data.url.startsWith('/ohif/')) throw new Error('Invalid viewer destination');
            viewer.location.replace(data.url);
          } catch (e) {
            viewer.close();
            setError(apiError(e));
          } finally {
            setBusy(false);
          }
        }}>
        {busy ? 'Opening viewer…' : 'Open OHIF viewer'}
      </Button>
      {error && <p role="alert">{error}</p>}
    </div>
  );
}
